.screen-container {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  max-height: calc(100% - 4rem);
  position: relative;

  > table {
    padding-inline-end: var(--spacing-inline-end-screen-container-child);
  }
}
